<div class="voice-dialog">
  <!-- ALI NOTE - Full-bleed canvas background (parallax waves) -->
  <canvas #waveCanvas class="wave-canvas"></canvas>

  <!-- Top bar with Close button -->
  <div class="topbar">
    <button class="close-btn" (click)="closeDialog()" aria-label="Close voice">
      ✕
    </button>
  </div>

  <!-- Center controls -->
  <div class="center-stack">
    <div class="mic-wrap" [style.transform]="'scale(' + iconPulse + ')'">
      <i class="fas fa-microphone"></i>
    </div>

    <div class="controls">
      <button class="pill" (click)="toggleMic()" [class.muted]="micMuted">
        <i class="fas" [class.fa-microphone-slash]="micMuted" [class.fa-microphone]="!micMuted"></i>
        <span>{{ micMuted ? 'Unmute' : 'Mute mic' }}</span>
      </button>

      <span class="live-chip" *ngIf="sessionActive">
        <i class="fas fa-wave-square"></i>
        Live
      </span>
    </div>

    <p class="hint">
      Speak naturally. Your voice and the model’s voice animate the waves.
    </p>
  </div>
</div>
